import React from "react";
import ButtonList from "./ButtonList";
import VideoContainer from "./VideoContainer";

const MainConatiner = () => {
  return (
    <div className="mt-16 md:ml-48 w-screen h-screen">
      <ButtonList />
      <VideoContainer />
    </div>
  );
};

export default MainConatiner;
